// extracted by mini-css-extract-plugin
export var section = "styles-module--section--3xy0I";
export var inner = "styles-module--inner--3ABnL";
export var title = "styles-module--title--1CYcj";
export var subTitle = "styles-module--subTitle--2MeU7";
export var date = "styles-module--date--9HCMP";
export var button = "styles-module--button--1nXwr";
export var text = "styles-module--text--2wkQs";
export var train = "styles-module--train--21PgM";
export var anim = "styles-module--anim--3qblU";